<template>
    <div>
        <div class="d-flex justify-content-center">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div
                        class="card"
                        v-loading="loading"
                        element-loading-text="Cargando..."
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.6)"
                    >
                        <div class="card-body">
                            <div class="">
                                <div class="">
                                    <div v-if="page1" id="info_usuario">
                                        <div class="form-group py-1">
                                            <label>Correo</label>
                                            <el-input
                                                type="email"
                                                v-model="form.email"
                                                placeholder="ejemplo@gmail.com"
                                                clearable
                                            >
                                                <template #prefix>
                                                    <el-icon
                                                        class="el-input__icon"
                                                    >
                                                        <Message />
                                                    </el-icon>
                                                </template>
                                            </el-input>
                                        </div>
                                        <div class="form-group py-1">
                                            <label>Confirmar correo</label>
                                            <el-input
                                                type="email"
                                                v-model="confirm_email"
                                                placeholder="ejemplo@gmail.com"
                                                clearable
                                            >
                                                <template #prefix>
                                                    <el-icon
                                                        class="el-input__icon"
                                                    >
                                                        <Message />
                                                    </el-icon>
                                                </template>
                                            </el-input>
                                        </div>

                                        <div class="form-group py-1">
                                            <label>Contraseña</label>
                                            <el-input
                                                v-model="form.password"
                                                placeholder="contraseña"
                                                show-password
                                            >
                                                <template #prefix>
                                                    <el-icon
                                                        class="el-input__icon"
                                                    >
                                                        <Lock />
                                                    </el-icon>
                                                </template>
                                            </el-input>
                                        </div>

                                        <div class="form-group py-1">
                                            <label>Confirmar contraseña</label>
                                            <el-input
                                                v-model="form.passwordValidate"
                                                placeholder="contraseña"
                                                show-password
                                            >
                                                <template #prefix>
                                                    <el-icon
                                                        class="el-input__icon"
                                                    >
                                                        <Lock />
                                                    </el-icon>
                                                </template>
                                            </el-input>
                                        </div>

                                        <div class="form-group py-1">
                                            <label>Curso</label>
                                            <br />
                                            <select
                                                v-model="form.course_id"
                                                @change="
                                                    getCourse(form.course_id)
                                                "
                                                class="form-control"
                                            >
                                                <option
                                                    value="0"
                                                    selected
                                                    disabled
                                                >
                                                    Seleccione un curso
                                                </option>
                                                <option
                                                    v-for="item in prod"
                                                    :value="item.id"
                                                >
                                                    {{ item.nombre }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div v-if="page2" id="info_personal">
                                        <div class="form-group py-1">
                                            <label>Nombres completos</label>
                                            <el-input
                                                v-model="form.name"
                                                placeholder="Jose Enrique Alfaro Leon"
                                                clearable
                                            >
                                                <template #prefix>
                                                    <el-icon
                                                        class="el-input__icon"
                                                    >
                                                        <User />
                                                    </el-icon>
                                                </template>
                                            </el-input>
                                        </div>

                                        <div class="form-group py-1">
                                            <label>Teléfono</label>
                                            <el-input
                                                type="number"
                                                v-model="form.phone"
                                                placeholder="876456342"
                                                clearable
                                            >
                                                <template #prefix>
                                                    <el-icon
                                                        class="el-input__icon"
                                                    >
                                                        <Iphone />
                                                    </el-icon>
                                                </template>
                                            </el-input>
                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <div class="form-group py-1">
                                                    <label
                                                        >Tipo de
                                                        documento</label
                                                    >
                                                    <br />
                                                    <select
                                                        v-model="
                                                            form.doc_type_id
                                                        "
                                                    >
                                                        <option
                                                            value="0"
                                                            disabled
                                                            selected
                                                        >
                                                            Seleccione una
                                                            acción
                                                        </option>
                                                        <option
                                                            v-for="item in documents"
                                                            :value="item.id"
                                                        >
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <div class="form-group py-1">
                                                    <label
                                                        >Número de
                                                        documento</label
                                                    >
                                                    <el-input
                                                        type="number"
                                                        v-model="
                                                            form.number_doc
                                                        "
                                                        clearable
                                                    >
                                                        <template #prefix>
                                                            <el-icon
                                                                class="el-input__icon"
                                                            >
                                                                <Postcard />
                                                            </el-icon>
                                                        </template>
                                                    </el-input>
                                                </div>
                                            </div>
                                            <!-- <div class="col">
                                                <div class="form-group py-1">

                                                    <label>País</label>
                                                    <br>
                                                    <select v-model="form.country">
                                                        <option value="0" disabled selected>Seleccione una acción</option>
                                                        <option v-for="item in country" :value="item.id">{{item.name}}</option>
                                                    </select>
                                                </div>

                                                <div class="form-group py-1">
                                                    <label>Fecha de nacimiento</label>
                                                    <br>
                                                    <el-date-picker v-model="form.birthday" type="date" placeholder="Selecciona una fecha" format="YYYY/MM/DD" value-format="YYYY-MM-DD" />
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div
                                v-if="page1 == true"
                                class="d-flex justify-content-center"
                            >
                                <button
                                    @click="this.nextPage()"
                                    class="btn"
                                    style="background-color: #ffc107"
                                >
                                    Siguiente
                                </button>
                            </div>
                            <div
                                v-if="page2 == true"
                                class="d-flex justify-content-center"
                            >
                                <button
                                    @click="this.previusPage()"
                                    class="btn mx-2"
                                    style="background-color: #ffc107"
                                >
                                    Anterior
                                </button>
                                <button
                                    @click="this.submit()"
                                    class="btn mx-2"
                                    :disabled="isSubmitting"
                                    style="background-color: #ffc107"
                                >
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <div
                        class="card"
                        v-loading="loading"
                        element-loading-text="Cargando..."
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.6)"
                    >
                        <div class="card-body">
                            <h5><b>Nombre del producto</b></h5>
                            <p
                                v-if="show_course_info"
                                v-html="course.nombre"
                            ></p>
                            <p v-else>Seleccione un curso</p>
                            <h5><b>Descripción</b></h5>
                            <p
                                v-if="show_course_info"
                                class="scroll"
                                v-html="course.descripcion"
                            ></p>
                            <p v-else class="scroll">-----</p>
                            <div class="row">
                                <div class="col">
                                    <h5><b>Precio</b></h5>
                                </div>
                                <div class="col">
                                    <p v-if="show_course_info">
                                        S/.{{ this.course.precio }}.
                                    </p>
                                    <p v-else>S/. 0.00</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        documents: Array,
        country: Array,
        prod: Array,
        id: Number,
    },

    data() {
        return {
            loading: false,
            extensions: ".jpeg, .jpg, .png",
            categories: [],
            course: {},
            form: {},
            fileList: [],
            isSubmitting: false,
            page1: true,
            page2: false,
            url0: "http://ipssoma.com/redirect/",
            //url0: 'http://127.0.0.1:8080/redirect/',
            url2: "",
            url3: "",
            confirm_email: "",
            show_course_info: false,
        };
    },
    created() {
        this.initForm();
    },
    methods: {
        nextPage() {
            if (this.validateFields()) {
                this.page1 = false;
                this.page2 = true;
            }
        },

        previusPage() {
            this.page2 = false;
            this.page1 = true;
        },

        async getCourse(id) {
            await axios.get(`/mostrar-curso/${id}`).then((response) => {
                this.course = response.data;
                this.show_course_info = true;
            });
        },

        initForm() {
            this.form = {
                email: "",
                password: "",
                passwordValidate: "",
                course_id: 0,

                name: "",
                phone: "",
                doc_type_id: 1,
                number_doc: "",
                country: 139,
                birthday: "",
            };
        },
        hasEspecialCharacters(text) {
            // Solo puede contener vocales con tilde A-Z  y 0-9
            const regex = new RegExp(
                /^[A-Za-z0-9\s\u00f1\u00d1-áéíóúÁÉÍÓÚ]+$/g
            );
            return regex.test(text);
        },
        validateFields() {
            var date = new Date();
            var current_date =
                date.getFullYear() +
                "-" +
                (date.getMonth() + 1) +
                "-" +
                date.getDate();
            var date1 = new Date(current_date);
            var date2 = new Date(this.form.birthday);

            if (
                !this.form.email ||
                this.form.email.trim() === "" ||
                this.form.email.length === 0
            ) {
                this.$message.warning("Email esta vacío!");
                return false;
            }

            if (this.form.email.length > 60) {
                this.$message.warning("Email demasiado largo!");
                return false;
            }

            if (
                !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
                    this.form.email
                )
            ) {
                this.$message.warning("Email incorrecto!");
                return false;
            }

            if (this.form.email != this.confirm_email) {
                this.$message.warning("Los correos ingresados no coinciden");
                return false;
            }

            if (
                !this.form.password ||
                this.form.password.trim() === "" ||
                this.form.password.length === 0
            ) {
                this.$message.warning("Contraseña esta vacía!");
                return false;
            }

            if (this.form.password.length > 60) {
                this.$message.warning("Contraseña demasiado larga!");
                return false;
            }

            if (
                !this.form.passwordValidate ||
                this.form.passwordValidate.trim() === "" ||
                this.form.passwordValidate.length === 0
            ) {
                this.$message.warning("Confirmar contraseña esta vacía!");
                return false;
            }

            if (this.form.password !== this.form.passwordValidate) {
                this.$message.warning("Las contraseñas no coinciden");
                return false;
            }

            if (this.form.course_id == 0) {
                this.$message.warning("Seleccione curso");
                return false;
            }
            return true;
        },

        validateFields2() {
            if (
                !this.form.name ||
                this.form.name.trim() === "" ||
                this.form.name.length === 0
            ) {
                this.$message.warning("Nombre esta vacío!");
                return false;
            }

            if (this.form.name.length > 60) {
                this.$message.warning("Nombre demasiado largo!");
                return false;
            }

            if (
                !this.form.phone ||
                this.form.phone.trim() === "" ||
                this.form.phone.length === 0
            ) {
                this.$message.warning("Ingrese su número telefónico");
                return false;
            }

            if (this.form.phone.length > 12) {
                this.$message.warning("Ingrese un número telefónico válido");
                return false;
            }

            if (this.form.doc_type_id == 0) {
                this.$message.warning("Seleccione tipo de documento");
                return false;
            }

            if (
                !this.form.number_doc ||
                this.form.number_doc.trim() === "" ||
                this.form.number_doc.length === 0
            ) {
                this.$message.warning("Documento esta vacío!");
                return false;
            }

            if (this.form.number_doc.length > 12) {
                this.$message.warning("Documento demasiado largo!");
                return false;
            }

            // if (this.form.country == 0) {
            //     this.$message.warning('Seleccione país');
            //     return false;
            // }

            // if (!this.form.birthday || this.form.birthday.trim() === '' || this.form.birthday.length === 0) {
            //     this.$message.warning('Fecha de nacimiento está vacío!');
            //     return false;
            // }

            // if (this.dateDiffInDays(date2, date1) < 6570) {
            //     this.$message.warning('Solo se permite registrar a mayores de edad!');
            //     return false;
            // }
            return true;
        },

        async submit() {
            if (this.validateFields2()) {
                this.isSubmitting = true;
                const formdata = new FormData();
                formdata.append("email", this.form.email);
                formdata.append("password", this.form.password);
                formdata.append("course_id", this.form.course_id);

                formdata.append("name", this.form.name);
                formdata.append("phone", this.form.phone);
                formdata.append("doc_type_id", this.form.doc_type_id);
                formdata.append("number_doc", this.form.number_doc);
                // formdata.append('country', this.form.country);
                // formdata.append('birthday', this.form.birthday);

                formdata.append("seller_id", this.id);

                try {
                    this.loading = true;
                    const request = await axios({
                        url: "/registrar-usuario",
                        method: "post",
                        data: formdata,
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });
                    if (request.data == "email repeat") {
                        await this.$message.warning("Este correo ya fue usado");
                        this.isSubmitting = false;
                        this.loading = false;
                    } else {
                        const response =
                            request.status == 200
                                ? this.$message.success(
                                      "El usuario ha sido registrado correctamente"
                                  )
                                : await this.$message.warning(
                                      "Error al validar datos"
                                  );
                        this.url2 = request.data;
                        this.url3 = `${this.url0}${this.url2}`;
                        this.isSubmitting = false;
                        this.loading = false;
                        setTimeout(this.redireccion(), 3000);
                    }
                } catch (error) {
                    this.isSubmitting = false;
                    this.loading = false;
                    console.log(error);
                }
            }
        },
        async redireccion() {
            window.location.href = this.url3;
        },

        dateDiffInDays(a, b) {
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            // Discard the time and time-zone information.
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        },
    },
};
</script>

<style scoped>
/* .scroll {
    max-height: 170px;
    overflow-y: auto;
    padding-right: 20px;
} */

.page2 {
    padding-top: 7px;
}

/* width */
/* ::-webkit-scrollbar {
    width: 20px;
} */

/* Track */
/* ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
} */

/* Handle */
::-webkit-scrollbar-thumb {
    background: #ffc107;
    border-radius: 10px;
}

option:hover {
    background-color: #343a40;
    color: white;
}
</style>
